import { useState, useMemo } from "react";

const allCities = [
  { name: "Portland", route: "/cities/portland", tagline: "Oregon's largest city — emergency & expedited passport services", highlights: ["Portland metro coverage", "Serving Beaverton, Gresham, Hillsboro"], badge: "Most Popular", status: "live" },
  { name: "Eugene", route: "/cities/eugene", tagline: "Lane County expedited passport processing", highlights: ["University of Oregon area", "Serving Springfield, Cottage Grove"], badge: "Most Popular", status: "live" },
  { name: "Salem", route: "/cities/salem", tagline: "Marion & Polk County rush passport services", highlights: ["State capital area", "Serving Keizer, Woodburn"], badge: null, status: "live" },
  { name: "Bend", route: "/cities/bend", tagline: "Central Oregon expedited passport hub", highlights: ["Deschutes County coverage", "Serving Redmond, Sisters, Prineville"], badge: null, status: "live" },
  { name: "Medford", route: "/cities/medford", tagline: "Southern Oregon passport courier service", highlights: ["Jackson County coverage", "Serving Ashland, Grants Pass"], badge: null, status: "live" },
  { name: "Corvallis", route: "/cities/corvallis", tagline: "Benton County expedited passport services", highlights: ["Oregon State University area", "Serving Albany, Lebanon"], badge: null, status: "live" },
  { name: "Beaverton", route: "/cities/beaverton", tagline: "Washington County passport processing", highlights: ["Beaverton metro coverage", "Serving Tigard, Tualatin"], badge: null, status: "live" },
  { name: "Hillsboro", route: "/cities/hillsboro", tagline: "Silicon Forest expedited passport services", highlights: ["Washington County coverage", "Serving Cornelius, Forest Grove"], badge: null, status: "live" },
  { name: "Gresham", route: "/cities/gresham", tagline: "East Portland metro passport services", highlights: ["Multnomah County coverage", "Serving Troutdale, Fairview"], badge: null, status: "live" },
  { name: "Lake Oswego", route: "/cities/lake-oswego", tagline: "Clackamas County luxury passport services", highlights: ["Lake Oswego area coverage", "Serving West Linn, Oregon City"], badge: null, status: "live" },
  { name: "Tigard", route: "/cities/tigard", tagline: "Washington County expedited passport processing", highlights: ["Tigard area coverage", "Serving Tualatin, Sherwood"], badge: null, status: "live" },
  { name: "Tualatin", route: "/cities/tualatin", tagline: "South metro passport services", highlights: ["Tualatin area coverage", "Serving Wilsonville, Newberg"], badge: null, status: "live" },
  { name: "Oregon City", route: "/cities/oregon-city", tagline: "Clackamas County passport processing", highlights: ["Historic Oregon City area", "Serving Gladstone, Milwaukie"], badge: null, status: "live" },
  { name: "West Linn", route: "/cities/west-linn", tagline: "Clackamas County expedited passports", highlights: ["West Linn area coverage", "Serving Lake Oswego, Oregon City"], badge: null, status: "live" },
  { name: "Milwaukie", route: "/cities/milwaukie", tagline: "Clackamas County passport services", highlights: ["Milwaukie area coverage", "Serving Sellwood, Oregon City"], badge: null, status: "live" },
  { name: "Happy Valley", route: "/cities/happy-valley", tagline: "Clackamas County expedited passport processing", highlights: ["Happy Valley area coverage", "Serving Clackamas, Damascus"], badge: null, status: "live" },
  { name: "Troutdale", route: "/cities/troutdale", tagline: "Columbia River Gorge passport services", highlights: ["Troutdale area coverage", "Serving Gresham, Wood Village"], badge: null, status: "live" },
  { name: "Forest Grove", route: "/cities/forest-grove", tagline: "Washington County passport processing", highlights: ["Forest Grove area", "Serving Cornelius, Hillsboro"], badge: null, status: "live" },
  { name: "Newberg", route: "#", tagline: "Yamhill County expedited passport services", highlights: ["Newberg area coverage", "Serving Dundee, McMinnville"], badge: null, status: "coming" },
  { name: "Wilsonville", route: "#", tagline: "Southern Portland metro passport services", highlights: ["Wilsonville area", "Serving Tualatin, Canby"], badge: null, status: "coming" },
  { name: "Sherwood", route: "#", tagline: "Washington County passport processing", highlights: ["Sherwood area coverage", "Serving Tualatin, Newberg"], badge: null, status: "coming" },
  { name: "Canby", route: "#", tagline: "Clackamas County expedited passports", highlights: ["Canby area coverage", "Serving Molalla, Oregon City"], badge: null, status: "coming" },
  { name: "Gladstone", route: "#", tagline: "Clackamas County passport services", highlights: ["Gladstone area coverage", "Serving Oregon City, West Linn"], badge: null, status: "coming" },
  { name: "Estacada", route: "#", tagline: "Clackamas County rural passport services", highlights: ["Estacada area coverage", "Serving Sandy, Molalla"], badge: null, status: "coming" },
  { name: "Sandy", route: "#", tagline: "Clackamas County mountain gateway passport services", highlights: ["Sandy area coverage", "Serving Estacada, Gresham"], badge: null, status: "coming" },
  { name: "Hood River", route: "#", tagline: "Columbia River Gorge expedited passports", highlights: ["Hood River area coverage", "Serving Cascade Locks, The Dalles"], badge: null, status: "coming" },
  { name: "The Dalles", route: "#", tagline: "Wasco County passport processing", highlights: ["The Dalles area coverage", "Serving Hood River, Maupin"], badge: null, status: "coming" },
  { name: "Pendleton", route: "#", tagline: "Eastern Oregon passport services", highlights: ["Umatilla County coverage", "Serving Hermiston, Milton-Freewater"], badge: null, status: "coming" },
  { name: "La Grande", route: "#", tagline: "Union County expedited passport services", highlights: ["La Grande area coverage", "Serving Baker City, Elgin"], badge: null, status: "coming" },
  { name: "Ontario", route: "#", tagline: "Eastern Oregon border passport services", highlights: ["Malheur County coverage", "Serving Payette ID, Nyssa"], badge: null, status: "coming" },
  { name: "Klamath Falls", route: "#", tagline: "Southern Oregon expedited passport processing", highlights: ["Klamath County coverage", "Serving Merrill, Malin"], badge: null, status: "coming" },
  { name: "Grants Pass", route: "#", tagline: "Josephine County passport services", highlights: ["Grants Pass area coverage", "Serving Rogue River, Cave Junction"], badge: null, status: "coming" },
  { name: "Ashland", route: "#", tagline: "Rogue Valley expedited passport services", highlights: ["Ashland area coverage", "Serving Medford, Talent"], badge: null, status: "coming" },
  { name: "Roseburg", route: "#", tagline: "Douglas County passport processing", highlights: ["Roseburg area coverage", "Serving Winston, Sutherlin"], badge: null, status: "coming" },
  { name: "Albany", route: "#", tagline: "Linn & Benton County passport services", highlights: ["Albany area coverage", "Serving Lebanon, Corvallis"], badge: null, status: "coming" },
  { name: "Lebanon", route: "#", tagline: "Linn County expedited passport services", highlights: ["Lebanon area coverage", "Serving Albany, Sweet Home"], badge: null, status: "coming" },
  { name: "Springfield", route: "#", tagline: "Lane County passport processing", highlights: ["Springfield area coverage", "Serving Eugene, Creswell"], badge: null, status: "coming" },
  { name: "Coos Bay", route: "#", tagline: "Coos County coastal passport services", highlights: ["Coos Bay area coverage", "Serving North Bend, Bandon"], badge: null, status: "coming" },
  { name: "Astoria", route: "#", tagline: "Clatsop County coastal passport services", highlights: ["Astoria area coverage", "Serving Warrenton, Seaside"], badge: null, status: "coming" },
  { name: "Seaside", route: "#", tagline: "Clatsop County beach town passport services", highlights: ["Seaside area coverage", "Serving Cannon Beach, Astoria"], badge: null, status: "coming" },
  { name: "Lincoln City", route: "#", tagline: "Lincoln County coastal passport processing", highlights: ["Lincoln City area", "Serving Newport, Depoe Bay"], badge: null, status: "coming" },
  { name: "Newport", route: "#", tagline: "Lincoln County expedited passport services", highlights: ["Newport area coverage", "Serving Lincoln City, Toledo"], badge: null, status: "coming" },
  { name: "Tillamook", route: "#", tagline: "Tillamook County coastal passport services", highlights: ["Tillamook area coverage", "Serving Rockaway Beach, Manzanita"], badge: null, status: "coming" },
  { name: "Redmond", route: "#", tagline: "Deschutes County high desert passport services", highlights: ["Redmond area coverage", "Serving Bend, Prineville, Sisters"], badge: null, status: "coming" },
  { name: "Prineville", route: "#", tagline: "Crook County rural passport services", highlights: ["Prineville area coverage", "Serving Redmond, Bend"], badge: null, status: "coming" },
  { name: "Hermiston", route: "#", tagline: "Umatilla County expedited passport processing", highlights: ["Hermiston area coverage", "Serving Pendleton, Boardman"], badge: null, status: "coming" },
  { name: "McMinnville", route: "#", tagline: "Yamhill County wine country passport services", highlights: ["McMinnville area coverage", "Serving Newberg, Sheridan"], badge: null, status: "coming" },
  { name: "Keizer", route: "#", tagline: "Marion County northern Salem passport services", highlights: ["Keizer area coverage", "Serving Salem, Woodburn"], badge: null, status: "coming" },
  { name: "Woodburn", route: "#", tagline: "Marion County expedited passport processing", highlights: ["Woodburn area coverage", "Serving Salem, Hubbard"], badge: null, status: "coming" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function OregonCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Oregon Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Oregon Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Oregon</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Oregon locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}